import React from 'react';
import * as PropTypes from 'prop-types';
import { Flexbox, Placeholder } from 'cw-ui-core';
import css from 'src/components/ListViewLoader/ListViewLoader.scss';
import cx from 'classnames';

// Since this is a generic component, it would be difficult without enforcing a column and row id
/* eslint react/no-array-index-key:0 */
const ListViewLoader = ({ rowCount = 10, columns = [], parentClass, ...props }) => {
    const LoadingComponent = () => {
        return (
            <div key={props.id} className={css.wrap}>
                {columns.map((column, colIndex) => {
                    if (column.stackCount && column.stackCount > 0) {
                        const nested = [...Array(column.stackCount)].map((disregard, index) => {
                            return (
                                <Flexbox className={parentClass} key={`${colIndex}_${index}`}>
                                    <Placeholder key={`placeholder_${colIndex}_${index}`} className={css.placeholder} />
                                </Flexbox>
                            );
                        });

                        return (
                            <Flexbox
                                key={`stackedColumn_${column.stackCount}+${colIndex}`}
                                className={cx(column.className, css.stackedColumn)}>
                                {nested}
                            </Flexbox>
                        );
                    }
                    return (
                        <Flexbox
                            className={cx(parentClass, column.className)}
                            key={`parent_${column.stackCount}+${colIndex}`}>
                            <Placeholder
                                key={`parentClass_${column.stackCount}+${colIndex}`}
                                className={css.placeholder}
                            />
                        </Flexbox>
                    );
                })}
            </div>
        );
    };

    return [...Array(rowCount)].map((disregard, index) => (
        <LoadingComponent key={index} id={index} columns={columns} parentClass={parentClass} />
    ));
};

ListViewLoader.propTypes = {
    rowCount: PropTypes.number,
    parentClass: PropTypes.string,
};

ListViewLoader.defaultProps = {
    rowCount: 10,
    column: [],
};

export default ListViewLoader;
